module.exports = "<div [ngClass]=\"show?'spinner-wrap local active':'spinner-wrap local'\">\n  <div class=\"spinner\"></div>\n</div>"